import React, { useState } from 'react';
import { UsersIcon, ShieldIcon, PlusIcon, SearchIcon, MoreVerticalIcon, CheckIcon, XIcon } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { users } from '../data/seedData';
import { UserRole } from '../data/types';
export function UsersRoles() {
  const {
    state
  } = useApp();
  const {
    language
  } = state;
  const [activeTab, setActiveTab] = useState<'users' | 'roles'>('users');
  const [searchQuery, setSearchQuery] = useState('');
  const filteredUsers = users.filter(user => user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase()));
  const permissions = [{
    feature: 'Dashboard',
    admin: true,
    officer: true,
    viewer: true
  }, {
    feature: 'View Land Records',
    admin: true,
    officer: true,
    viewer: true
  }, {
    feature: 'Create Land Record',
    admin: true,
    officer: true,
    viewer: false
  }, {
    feature: 'Edit Land Record',
    admin: true,
    officer: true,
    viewer: false
  }, {
    feature: 'Delete Land Record',
    admin: true,
    officer: false,
    viewer: false
  }, {
    feature: 'Upload Documents',
    admin: true,
    officer: true,
    viewer: false
  }, {
    feature: 'Manage Master Data',
    admin: true,
    officer: false,
    viewer: false
  }, {
    feature: 'Manage Users',
    admin: true,
    officer: false,
    viewer: false
  }, {
    feature: 'Generate Reports',
    admin: true,
    officer: true,
    viewer: true
  }];
  return <div className="p-4 lg:p-6 space-y-6" data-id="element-1193">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1194">
        <div data-id="element-1195">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1196">
            {language === 'en' ? 'Users & Roles' : 'ব্যবহারকারী ও ভূমিকা'}
          </h1>
          <p className="text-gray-600 mt-1" data-id="element-1197">
            {language === 'en' ? 'Manage system access and permissions' : 'সিস্টেম অ্যাক্সেস এবং অনুমতি পরিচালনা করুন'}
          </p>
        </div>
        {activeTab === 'users' && <button className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1198">
            <PlusIcon className="w-5 h-5" data-id="element-1199" />
            <span data-id="element-1200">Add User</span>
          </button>}
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-1201">
        <div className="flex gap-6" data-id="element-1202">
          <button onClick={() => setActiveTab('users')} className={`flex items-center gap-2 pb-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'users' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1203">
            <UsersIcon className="w-4 h-4" data-id="element-1204" />
            Users
          </button>
          <button onClick={() => setActiveTab('roles')} className={`flex items-center gap-2 pb-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'roles' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1205">
            <ShieldIcon className="w-4 h-4" data-id="element-1206" />
            Roles & Permissions
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'users' ? <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1207">
          <div className="p-4 border-b border-gray-200" data-id="element-1208">
            <div className="relative max-w-md" data-id="element-1209">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1210" />
              <input type="text" placeholder="Search users..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1211" />
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-1212">
            <table className="w-full text-sm" data-id="element-1213">
              <thead data-id="element-1214">
                <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1215">
                  <th className="text-left px-6 py-3 font-medium text-gray-600" data-id="element-1216">
                    User
                  </th>
                  <th className="text-left px-6 py-3 font-medium text-gray-600" data-id="element-1217">
                    Role
                  </th>
                  <th className="text-left px-6 py-3 font-medium text-gray-600" data-id="element-1218">
                    Status
                  </th>
                  <th className="text-left px-6 py-3 font-medium text-gray-600" data-id="element-1219">
                    Last Login
                  </th>
                  <th className="text-right px-6 py-3 font-medium text-gray-600" data-id="element-1220">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-1221">
                {filteredUsers.map(user => <tr key={user.id} className="hover:bg-gray-50 transition-colors" data-id="element-1222">
                    <td className="px-6 py-3" data-id="element-1223">
                      <div data-id="element-1224">
                        <p className="font-medium text-gray-900" data-id="element-1225">{user.name}</p>
                        <p className="text-gray-500 text-xs" data-id="element-1226">{user.email}</p>
                      </div>
                    </td>
                    <td className="px-6 py-3" data-id="element-1227">
                      <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${user.role === 'Admin' ? 'bg-purple-100 text-purple-700' : user.role === 'Legal Officer' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-1228">
                        {user.role}
                      </span>
                    </td>
                    <td className="px-6 py-3" data-id="element-1229">
                      {user.status === 'Active' ? <span className="text-green-600 text-xs font-medium flex items-center gap-1" data-id="element-1230">
                          <div className="w-1.5 h-1.5 rounded-full bg-green-600" data-id="element-1231" />{' '}
                          Active
                        </span> : <span className="text-gray-500 text-xs font-medium flex items-center gap-1" data-id="element-1232">
                          <div className="w-1.5 h-1.5 rounded-full bg-gray-400" data-id="element-1233" />{' '}
                          Inactive
                        </span>}
                    </td>
                    <td className="px-6 py-3 text-gray-500" data-id="element-1234">
                      {user.lastLogin}
                    </td>
                    <td className="px-6 py-3 text-right" data-id="element-1235">
                      <button className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg" data-id="element-1236">
                        <MoreVerticalIcon className="w-4 h-4" data-id="element-1237" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div> : <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1238">
          <div className="overflow-x-auto" data-id="element-1239">
            <table className="w-full text-sm" data-id="element-1240">
              <thead data-id="element-1241">
                <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1242">
                  <th className="text-left px-6 py-4 font-medium text-gray-600" data-id="element-1243">
                    Feature / Permission
                  </th>
                  <th className="text-center px-6 py-4 font-medium text-gray-600 w-32" data-id="element-1244">
                    Admin
                  </th>
                  <th className="text-center px-6 py-4 font-medium text-gray-600 w-32" data-id="element-1245">
                    Legal Officer
                  </th>
                  <th className="text-center px-6 py-4 font-medium text-gray-600 w-32" data-id="element-1246">
                    Viewer
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-1247">
                {permissions.map((perm, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-1248">
                    <td className="px-6 py-3 font-medium text-gray-900" data-id="element-1249">
                      {perm.feature}
                    </td>
                    <td className="px-6 py-3 text-center" data-id="element-1250">
                      {perm.admin ? <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-1251" /> : <XIcon className="w-5 h-5 text-gray-300 mx-auto" data-id="element-1252" />}
                    </td>
                    <td className="px-6 py-3 text-center" data-id="element-1253">
                      {perm.officer ? <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-1254" /> : <XIcon className="w-5 h-5 text-gray-300 mx-auto" data-id="element-1255" />}
                    </td>
                    <td className="px-6 py-3 text-center" data-id="element-1256">
                      {perm.viewer ? <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-1257" /> : <XIcon className="w-5 h-5 text-gray-300 mx-auto" data-id="element-1258" />}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
    </div>;
}